import Vue from 'vue'
import App from './App'

/* eslint-disable no-new */
window.vdesigner = new Vue({
  el: 'body',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js